
import React from 'react';
import { Link } from 'react-router-dom';
import CONSTANT from './../../../constant';

import { getDesignationList, updateDesignationList } from '../../../actions/MasterAction';
import Header from '../../../component/common/AdminHeader';
import { onChange, validateForm, getDateParts } from './../../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            rank: { name: 'rank', value: '', error: '', isRequired: true },
            sort: { name: 'sort', value: '1', error: '' },
            page: 1,
            limit: 10,
            list: undefined,
            tableIndex: 0,
            showLoader: true
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        const { page, list, rank, tableIndex, sort } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="page-title">All Designation</h1>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <Link to={CONSTANT.component.adminAddDesignation.url} className="btn btn-sm submit-button">
                                        <i className="fa fa-plus-circle mr-2" />
                                        Add Designation
                                    </Link>
                                </div>
                                <div className="col-md-3"></div>
                                <div className="col-md-3">
                                    <select
                                        name={sort.name}
                                        value={sort.value}
                                        onChange={this.onChange}
                                        className="form-control"
                                    >
                                        <option value='1'>Sort by - Name Asc</option>
                                        <option value='2'>Sort by - Rank Asc</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <div className="list-container">
                                        <div className="table-container">
                                            <div className="table-wrapper radius-4">
                                        <table className="tablen">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className="text-nowrap">#</th>
                                                        <th scope="col" className="text-nowrap">Name</th>
                                                        <th scope="col" className="text-nowrap">Rank</th>
                                                        <th scope="col" className="text-nowrap"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    list === undefined &&
                                                    <tr>
                                                        <td colSpan={4} className="text-center">Loading...</td>
                                                    </tr>
                                                }
                                                {
                                                    list !== undefined && list.length === 0 &&
                                                    <tr>
                                                        <td colSpan={4} className="text-center">No records found</td>
                                                    </tr>
                                                }
                                                {
                                                    list !== undefined && list.map((item: any, index: number) => {
                                                        const detailPageURL = CONSTANT.component.adminEditDesignation.url.replace(':code', item.code);
                                                        const dated = getDateParts(item.modifiedOn);
                                                        return (
                                                            <tr className="c-pointer" key={index + 1} onClick={() => this.openDetailPage(detailPageURL)}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.name}</td>
                                                                <td>{item.rank}</td>
                                                                <td><i className="fa fa-pencil" /></td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loadList = () => {
        const { sort } = this.state;
        getDesignationList(sort.value).then((res: any) => {
            if (res)
                this.setState({ list: res.result });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => { this.loadList() });
    }

    onChange = (e: any) => {
        onChange(this, e.target.name, e.target.value, () => {
            this.loadList();
        });
    }
}

export default ComponentName;